import { useMemo } from 'react';
import useSWR from 'swr';
import type { SWRConfiguration } from 'swr';

import { fetcher, endpoints } from '@/lib/axios';
import type { IMentor, IMentorsResponse } from '@/types/mentor';

// ----------------------------------------------------------------------

const swrOptions: SWRConfiguration = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  shouldRetryOnError: false,
};

// ----------------------------------------------------------------------

/**
 * Fetches the active mentors shown on the "Enseigner" page.
 * Endpoint: GET /api/v1/mentors
 */
export function useGetMentors() {
  const { data, isLoading, error, isValidating } = useSWR<IMentorsResponse>(
    endpoints.mentors.list,
    fetcher,
    swrOptions
  );

  const memoizedValue = useMemo(
    () => ({
      mentors: (data?.data ?? []) as IMentor[],
      mentorsLoading: isLoading,
      mentorsError: error as Error | undefined,
      mentorsValidating: isValidating,
      mentorsEmpty: !isLoading && !(data?.data?.length),
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}
